export default __webpack_public_path__ + "static/media/Fiche_Loyal.3253e1a7.svg";